import React from "react";
import PropTypes from "prop-types";

const LoadingTableNormal = props => {
  const numColumn = Number(props.countColumn);
  const numRow = Number(props.countRow);
  return (
    <React.Fragment>
      <div className="row">
        <div className="col">
          <table className="table">
            <thead>
              <tr>
                {[...Array(numColumn)].map((x, i) => (
                  <th key={i} className="placeholder-wave">
                    <button className="btn btn-secondary disabled placeholder w-100"></button>
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {[...Array(numRow)].map((x, i) => (
                <tr key={i}>
                  {[...Array(numColumn)].map((x, i) => (
                    <td key={i} className="placeholder-glow">
                      <button className="btn btn-primary disabled placeholder w-100"></button>
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </React.Fragment>
  );
};

LoadingTableNormal.propTypes = {
  countColumn: PropTypes.string,
  countRow: PropTypes.string,
};

LoadingTableNormal.defaultProps = {
  countColumn: "9",
  countRow: "3",
};

export default LoadingTableNormal;
